import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import { error } from '@angular/compiler/src/util';
import { Router } from '@angular/router';

import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { stringify } from 'querystring';

import { NgxSpinnerService } from "ngx-spinner";
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  title = 'Evolvtax Login';

  public adminLocalStorage:any;

  public email: any;
  public password: any;
  public url: string;

  constructor(public service: UserService, public router: Router,
    public toastr: ToastrService,
    private SpinnerService: NgxSpinnerService,
    private titleService:Title) {
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.url = this.router.url;
  }

  loginClose()
  {
    setTimeout(() => {
      this.router.navigate(['home']);
    }, 100);
  }

  loginFunction() {
    this.adminLocalStorage = localStorage.getItem('userDetails');
    if (!this.email) {
      this.toastr.warning("Please enter Email");
      return;
    } else if (!this.password) {
      this.toastr.warning("Please enter Password");
      return;
    }else if(this.adminLocalStorage)
    {
      return this.toastr.error("Please Logout Admin Portal to access Citizen Services");
    }
     else {
      let obj = {
        'email': this.email,
        'password': this.password
      }
      this.SpinnerService.show();
      this.service.loginFunction(obj).subscribe((res: any) => {
        this.SpinnerService.hide();
        if (res.code === 200) {  
          // localStorage.clear(); 
          this.service.loggedIn = true;   
          setTimeout(() => {
            this.service.getYears().subscribe((res: any) => {
              localStorage.setItem('years', JSON.stringify(res.data));
            });
      
          }, 100);
          // Local Storage for login to store all data of user
          localStorage.setItem('data',JSON.stringify(res.data));
          this.toastr.success("Login Successful");
          this.router.navigate(['/dashboard']);
        }else {
          this.toastr.error(res.message);
          this.router.navigate(['/login']);
        }
      },
        err => {
          console.log(err);
        }
      )
    }
  }
}
